export const menudata = [
  {
    id: 1,
    title: "Home",
    path: "/",
  },
  {
    id: 2,
    title: "About",
    path: "/about",
  },
  {
    id: 3,
    title: "Case Studies",
    path: "/casestudies",
  },
  {
    id: 4,
    title: "Products",
    path: "/products",
  },
  {
    id: 5,
    title: "Contact",
    path: "/contact",
  },
  {
    id: 6,
    title: "Careers",
    path: "/careers",
  },
];

export const subMenuData = [
  {
    id: 3,
    title: "Facilities",
    path: "/facilities",
  },
  {
    id: 2,
    title: "Expertise",
    path: "/expertise",
  },
  {
    id: 3,
    title: "News Section",
    path: "/newssection",
  },
  {
    id: 5,
    title: "Certification",
    path: "/certification",
  },
  {
    id: 6,
    title: "Gallery",
    path: "/gallery",
  },
  {
    id: 7,
    title: "Teams",
    path: "/teams",
  },
];

export const responsiveMenu = [
  {
    title: "Home",
    path: "/",
    id: "#home",
  },
  {
    title: "About",
    path: "/about",
    id: "#about",
  },
  {
    title: "Case Studies",
    path: "/casestudies",
    id: "#casestudy",
  },
  {
    title: "Products",
    path: "/products",
    id: "#products",
  },
  {
    title: "Contact",
    path: "/contact",
    id: "#contact",
  },
  {
    title: "Careers",
    path: "/careers",
  },

  {
    title: "Facilities",
    path: "/facilities",
  },
  {
    title: "Expertise",
    path: "/expertise",
  },
  {
    title: "News Section",
    path: "/newssection",
  },
  {
    id: 5,
    title: "Certification",
    path: "/certification",
  },
  {
    id: 6,
    title: "Gallery",
    path: "/gallery",
  },
  {
    id: 7,
    title: "Teams",
    path: "/teams",
  },
  {
    id: 8,
    title: "Brochure",
    path: "/allbrocedure",
  },
];
